import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const UserModule = {
  namespaced: true,

  state: {
    user: {
      active: true
    },
    users: []
  },

  actions: {
    async createUser ({ commit, state }, user) {
      commit('LoaderModule/setLoaders', {
        'modifyingUser': true
      }, { root: true })

      await PaApi().post(
        '/admin/users', {
          user: user
        }
      ).then((resp) => {
        commit('LoaderModule/setLoaders', {
          'gettingUser': false
        }, { root: true })

        commit('storeUser', resp)
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'modifyingUser': false
        }, { root: true })
      })
    },

    async updateUser ({ commit, state }, user) {
      commit('LoaderModule/setLoaders', {
        'modifyingUser': true
      }, { root: true })

      await PaApi().put(
        `/admin/users/${user.id}`, {
          user: state.user
        }
      ).finally(() => {
        commit('LoaderModule/setLoaders', {
          'modifyingUser': false
        }, { root: true })
      })
    },

    setUserRoleId ({ commit, state }, roleId) {
      commit('UserModule/storeUserRoleId', roleId, { root: true })
    },

    async requestPasswordReset ({ commit, state }, email) {
      commit('LoaderModule/setLoaders', {
        'sendingPasswordResetEmail': true
      }, { root: true })

      await PaApi().post(
        '/admin/users/request_password_reset', {
          user: {
            email: email
          }
        }
      ).finally(() => {
        commit('LoaderModule/setLoaders', {
          'sendingPasswordResetEmail': false
        }, { root: true })
      })
    },

    async getUser ({ commit, state }, id) {
      commit('LoaderModule/setLoaders', {
        'gettingUser': true
      }, { root: true })

      await PaApi().get(
        `/admin/users/${id}`
      ).then((resp) => {
        commit('LoaderModule/setLoaders', {
          'gettingUser': false
        }, { root: true })

        commit('storeUser', resp)
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'gettingUser': false
        }, { root: true })
      })
    },

    async newUser ({ commit, state }) {
      commit('storeNewUser')
    },

    async debugUserAuth ({ commit, state }, params) {
      commit('LoaderModule/setLoaders', {
        'debugUserAuth': true
      }, { root: true })

      await PaApi().post(
        `/admin/debug_user_auth`, {
          user: params
        }
      ).then((resp) => {
        commit('storeUserDebug', resp)
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'debugUserAuth': false
        }, { root: true })
      })
    },

    async deselectUserAttr ({ commit, state }, attr) {
      commit('deselectUserAttr', attr)
    },

    async verifyUser ({ commit, state }, userId) {
      commit('LoaderModule/setLoaders', {
        verifyUser: true
      }, { root: true })

      await PaApi().post(
        `/admin/users/${userId}/verify`
      ).then((resp) => {
        commit('storeUser', resp)
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          verifyUser: false
        }, { root: true })
      })
    },

    async unverifyUser ({ commit, state }, userId) {
      commit('LoaderModule/setLoaders', {
        'verifyUser': true
      }, { root: true })

      await PaApi().delete(
        `/admin/users/${userId}/verify`
      ).then((resp) => {
        commit('storeUser', resp)
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'verifyUser': false
        }, { root: true })
      })
    },

    async getAvailableContributors ({ commit, state }) {
      commit('LoaderModule/setLoaders', {
        'gettingUsers': true
      }, { root: true })

      await PaApi().get(
        `/admin/available_contributors?page[size]=500`
      ).then((resp) => {
        commit('LoaderModule/setLoaders', {
          'gettingUsers': false
        }, { root: true })

        commit('storeUsers', resp)
        commit('sortUsers')
      }).finally(() => {
        commit('LoaderModule/setLoaders', {
          'gettingUsers': false
        }, { root: true })
      })
    }
  },

  mutations: {
    deselectUserAttr (state, attr) {
      state.user[attr] = false
    },

    filterUnnamedUsers (state) {
      state.users = state.users.filter(user => user.name)
    },

    sortUsers (state, users = undefined) {
      state.users = users || state.users
      // Sort authors by last name.
      state.users.sort(function (a, b) {
        const nameA = a.sort_name.toUpperCase()
        const nameB = b.sort_name.toUpperCase()

        if (nameA < nameB) {
          return -1
        }

        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
    },

    storeUserRoleId (state, roleId) {
      state.user.role_id = roleId
    },

    storeUser (state, payload) {
      baseOpts.recursive = true
      state.user = processSuccess(payload, baseOpts)
      state.user.inactive = !state.user.active
      state.user.private_display_name = state.user.name || state.user.username
    },

    storeNewUser (state) {
      state.user = {
        active: true
      }
    },

    storeUserDebug (state, payload) {
      state.user = payload.data.data
    },

    storeUsers (state, payload) {
      state.users = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/UserModule.js